import { render, staticRenderFns } from "./DonorVentilatorSettingsPrint.vue?vue&type=template&id=f85df928"
import script from "./DonorVentilatorSettingsPrint.vue?vue&type=script&lang=js"
export * from "./DonorVentilatorSettingsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports